import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { PopupService } from '../../../services/popup.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-user-email-verification',
  templateUrl: './user-email-verification.component.html',
  styleUrls: ['./user-email-verification.component.less']
})
export class UserEmailVerificationComponent implements OnInit {

  constructor(public activatedRoute: ActivatedRoute, public userService: UserService,
    public router: Router, public notificationService: NotificationService, public popupService: PopupService) { }

  paramSubscription: Subscription;
  isFetching: boolean = false;

  ngOnInit() {
  }

  ngAfterViewInit() {
    if(this.userService.getLoggedIn() && !this.isFetching && Object.keys(this.activatedRoute.snapshot.queryParams).length>0) {
      this.isFetching = true;
      this.userService.verifyUserEmail(this.activatedRoute.snapshot.queryParams).subscribe((response)=>{
        response.verified? 
        this.notificationService.info('Email successfully verified.'):
        this.notificationService.error('Email verification failed. Please try again.');
        this.closePopup();
      }, (error)=>{
        this.closePopup();
        throw(error);
      });
    } else {
      this.closePopup();
    }
  }

  closePopup() {
    this.isFetching = false;
    this.router.navigate([this.userService.getLoggedIn() ? '/map' : '/map/log-in'], {
      queryParamsHandling: this.userService.getLoggedIn() ? null : 'merge'
    });
  }

  ngOnDestroy() {
    this.paramSubscription && this.paramSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/user-email-verification/user-email-verification.component.ts